var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Tasks__View", attrs: { dir: "rtl" } },
    [
      _c("EntityListLayout", {
        ref: "list",
        class: { "is-hiding-table": _vm.isPlanTab && _vm.view !== "list" },
        attrs: { tabs: _vm.tabs, namespace: "courseTasks" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_c("h1", [_vm._v("משימות")])]
            },
            proxy: true,
          },
          {
            key: "counter",
            fn: function (slotProps) {
              return [
                _vm._v(' סה"כ '),
                _c("b", [_vm._v(_vm._s(_vm.getTotalRecords(slotProps)) + " ")]),
                _vm.selectedMemberships(slotProps.tab).length
                  ? _c("span", [
                      _vm._v(" | נבחרו "),
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.selectedMemberships(slotProps.tab).length)
                        ),
                      ]),
                      _vm._v(" משימות, סה״כ זמן "),
                      _c("b", [
                        _vm._v(
                          _vm._s(
                            _vm.toHours(
                              _vm.totalMinutes(
                                _vm.selectedMemberships(slotProps.tab)
                              )
                            )
                          )
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]
            },
          },
          {
            key: "button",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "Tasks__ListActions" },
                  [
                    _c("div", { staticClass: "Tasks__ViewToggle" }, [
                      _c(
                        "div",
                        {
                          staticClass: "toggle",
                          class: { "is-disabled": !_vm.isPlanTab },
                        },
                        [
                          _c(
                            "button",
                            {
                              class: { active: _vm.activeView === "list" },
                              attrs: { disabled: !_vm.isPlanTab },
                              on: {
                                click: function ($event) {
                                  _vm.view = "list"
                                },
                              },
                            },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "format-list-bulleted",
                                  size: "is-small",
                                },
                              }),
                              _vm._v(" רשימה "),
                            ],
                            1
                          ),
                          _c(
                            "button",
                            {
                              class: { active: _vm.activeView === "calendar" },
                              attrs: { disabled: !_vm.isPlanTab },
                              on: {
                                click: function ($event) {
                                  _vm.view = "calendar"
                                },
                              },
                            },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "calendar-month",
                                  size: "is-small",
                                },
                              }),
                              _vm._v(" לוח חודשי "),
                            ],
                            1
                          ),
                          _c(
                            "button",
                            {
                              class: { active: _vm.activeView === "day" },
                              attrs: { disabled: !_vm.isPlanTab },
                              on: {
                                click: function ($event) {
                                  _vm.view = "day"
                                },
                              },
                            },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "calendar-today",
                                  size: "is-small",
                                },
                              }),
                              _vm._v(" יומי "),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                    _c(
                      "b-button",
                      {
                        attrs: { type: "is-primary", "icon-left": "plus" },
                        on: {
                          click: function ($event) {
                            return _vm.openAssign()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.assignButtonLabel))]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm.isPlanTab && _vm.view === "calendar"
        ? _c(
            "div",
            { staticClass: "Tasks__Calendar" },
            [
              _c("Calendar", {
                attrs: { "show-hint": false },
                on: { "month-change": _vm.onMonthChange },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "cell-body",
                      fn: function ({ cell }) {
                        return [
                          _c(
                            "div",
                            { staticClass: "task-chips" },
                            [
                              _vm._l(
                                _vm.tasksByDate[cell.dateStr] || [],
                                function (t) {
                                  return _c(
                                    "div",
                                    {
                                      key: t.id,
                                      staticClass: "task-chip",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.openAssign(t)
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "dot",
                                        style: {
                                          background: _vm.timeColor(
                                            t.timeWindow
                                          ),
                                        },
                                      }),
                                      _c("span", { staticClass: "txt" }, [
                                        _vm._v(_vm._s(t.taskName)),
                                      ]),
                                    ]
                                  )
                                }
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "open-day",
                                  attrs: { type: "button", title: "פתח יום" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.openDay(cell.dateStr)
                                    },
                                  },
                                },
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      icon: "calendar-today",
                                      size: "is-small",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "day-note",
                                  class: {
                                    "has-note": !!_vm.dayComments[cell.dateStr],
                                  },
                                  attrs: {
                                    type: "button",
                                    title:
                                      _vm.dayComments[cell.dateStr] ||
                                      "הוסף הערה ליום",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.openDayComments(cell.dateStr)
                                    },
                                  },
                                },
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      icon: _vm.dayComments[cell.dateStr]
                                        ? "comment-text"
                                        : "comment-plus-outline",
                                      size: "is-small",
                                    },
                                  }),
                                ],
                                1
                              ),
                              !cell.isPast
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "add",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.openAssign(
                                            null,
                                            cell.dateStr
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("+")]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2581873669
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.isPlanTab && _vm.view === "day"
        ? _c(
            "div",
            { staticClass: "Tasks__Day" },
            [
              _c("PlanDayOrder", {
                attrs: {
                  "program-type-id": _vm.activeProgramTypeId,
                  "initial-date": _vm.selectedDayDate,
                },
                on: {
                  "day-comments-saved": _vm.onDayCommentsSaved,
                  "task-unassigned": _vm.onTaskUnassigned,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }